var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercentageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_124051",
    "data-name": "Group 124051",
    transform: "translate(-305 -247)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(305 247)",
    fill: "#1b4a83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-percentage",
    "data-name": "Icon awesome-percentage",
    d: "M3.162,7.662a1.852,1.852,0,1,0-2.619,0A1.852,1.852,0,0,0,3.162,7.662Zm7.409,4.79a1.852,1.852,0,1,0,0,2.619A1.852,1.852,0,0,0,10.571,12.451Zm-.056-6.7L9.86,5.1a.926.926,0,0,0-1.31,0L.6,13.05a.926.926,0,0,0,0,1.31l.655.655a.926.926,0,0,0,1.31,0l7.952-7.952A.926.926,0,0,0,10.515,5.753Z",
    transform: "translate(313.443 250.943)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageIcon);
export default __webpack_public_path__ + "static/media/percentageIcon.ca11233e1dc6d987bfa83785387dab9f.svg";
export { ForwardRef as ReactComponent };